import React, { useContext, useMemo } from 'react';
import { GasMonitorContext } from '../../context';
import styles from './index.module.scss';
import { Carousel, Empty, Spin } from 'antd';
import { formatThousandUnit } from '@/utils/utils';
import { isEmpty } from 'lodash-es';

interface TopMetricsProps {
  className?: string;
}

const TopMetrics: React.FC<TopMetricsProps> = ({ className }) => {
  const { monthAndAnnualData: data, monthAndAnnualLoading: loading } = useContext(GasMonitorContext);

  const monthlyDetails = useMemo(() => {
    return data?.monthlyAndAnnualGasUsageDetails ?? [];
  }, [data]);

  const annualDetails = useMemo(() => {
    return data?.annualGasUsageDetails ?? [];
  }, [data]);

  // 是否需要轮播（超过3个介质）
  const needCarousel = useMemo(() => {
    return monthlyDetails.length > 3 || annualDetails.length > 3;
  }, [monthlyDetails, annualDetails]);

  const renderCards = (details: typeof monthlyDetails) => {
    if (needCarousel && details.length > 3) {
      return (
        <Carousel autoplay autoplaySpeed={10000} dots={false} slidesToShow={3} slidesToScroll={1}>
          {details.map((item, idx) => (
            <div key={item.mediumId ?? idx} className={styles.metricCard}>
              <div className={styles.cardTitle}>
                {item.mediumName ?? '--'}({item.physicalUnitName ?? '--'})
              </div>
              <div className={styles.cardValue}>{formatThousandUnit(item.usage)}</div>
            </div>
          ))}
        </Carousel>
      );
    }
    return (
      <div className={styles.cardsGroup}>
        {details.slice(0, 3).map((item, idx) => (
          <div key={item.mediumId ?? idx} className={styles.metricCard}>
            <div className={styles.cardTitle}>
              {item.mediumName ?? '--'}({item.physicalUnitName ?? '--'})
            </div>
            <div className={styles.cardValue}>{formatThousandUnit(item.usage)}</div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Spin spinning={loading}>
      <div className={`${styles.topMetricsContainer} ${className ?? ''}`}>
        <div className={styles.metricsRow}>
          <div className={styles.groupLabel}>本月用气</div>
          {isEmpty(monthlyDetails) ? (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          ) : (
            <div className={styles.cardsWrapper}>{renderCards(monthlyDetails)}</div>
          )}
        </div>
        <div className={styles.metricsRow}>
          <div className={styles.groupLabel}>本年用气</div>
          {isEmpty(annualDetails) ? (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          ) : (
            <div className={styles.cardsWrapper}>{renderCards(annualDetails)}</div>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default TopMetrics;
